import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getScheduleSummary = api((id) =>
    query(
        gql`
            query GetScheduleSummary($id: String!) {
                getScheduleSummary(id: $id)
            }
        `,
        { id },
        { returns: "getScheduleSummary" }
    )
)
